<template>
    <modal :has-padding="false" max-width="600" v-model="show">
        <button
            class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="reset"
            v-if="canCreateCampaing"
        >
            {{ $t("message.campaigns.message.createCampaign") }}
        </button>

        <div :key="id">
            <app-nav-tabs
                data-padding="5px 50px 0 50px"
                v-model="tab"
                :data-tabs="tabs"
            ></app-nav-tabs>

            <app-advertising-form-section
                ref="body"
                v-show="isGeneralTab"
                v-model="data"
                :readonly="readonly"
                @input="input"
                @valid="save"
                @to-general-tab="tab = tabs[0]"
            ></app-advertising-form-section>

            <filter-tree
                v-if="isFilterTab"
                :isPartnerCampaign="isPartner"
                :list="list"
                :loaded="loaded"
                :load-error="loadError"
                :anunciante="isAnunciante"
                advertising
                @load="load"
                @toggleNode="toogleNode"
                @toggle-establishment="toggleNodeEstablishment"
                @set-priority="setPriority"
                @setIsOpenArray="setIsOpenArray"
            />

            <div class="card-footer" v-if="!readonly">
                <button
                    class="btn btn-primary btn-round"
                    @click="$refs.body.validate()"
                >
                    {{
                        edit
                            ? $t("message.campaigns.message.saveEdit")
                            : isGeneralTab
                            ? $t("message.generics.message.advance")
                            : $t("message.generics.message.save")
                    }}
                </button>

                <router-link
                    v-if="edit"
                    :to="editUrl"
                    tag="button"
                    class="btn btn-secondary btn-round"
                >
                    {{ $t("message.campaigns.message.editScreens") }}
                </router-link>
            </div>
        </div>
    </modal>
</template>

<script>
// import LocalTree from "@components/modules/local/tree/LocalTree";
import FilterTree from "@components/modules/advertising/modal/filter-tree/FilterTree";
import AppNavTabs from "@components/NavTabs";
import AppAdvertisingFormSection from "./components/AdvertisingFormSection";
// import AppAdvertisingDevicesSection from './components/AdvertisingDevicesSection'
import EventBus from "@packages/event-bus";
import Modal from "@/components/generic/Modal";
import { LOCAL_TREE_TYPE, normalizeSelection } from "@packages/util/tree/local-tree";
import { debounce } from "lodash";

export default {
    components: {
        AppNavTabs,
        AppAdvertisingFormSection,
        // LocalTree,
        Modal,
        FilterTree,
        // AppAdvertisingDevicesSection,
    },

    data() {
        return {
            value: [],
            locals: [],
            establishments: [],
            show: false,
            edit: false,
            id: null,
            data: {},
            tab: null,
            isFilterTabDisabled: true,
            isGeneralTabDisabled: false,
            localsLoaded: false,
            establishmentsLoaded: false,
            localsError: false,
            establishmentsError: false,
            localsRequestId: 0,
            establishmentsRequestId: 0,
            pendingToggleCount: 0,
            needsLocalFilterReload: false,
            isOpenArray: [],
            selectedEstablishments: {},
        };
    },

    computed: {
        isAnunciante() {
            return this.$store.state.users.user.tipo === "ANUNCIANTE";
        },
        tabs() {
            return [
                {
                    value: "GENERAL",
                    label: this.$t("message.generics.message.general"),
                    disabled: this.isGeneralTabDisabled,
                },
                {
                    value: "FILTER",
                    label: this.isPartner
                        ? this.$t("message.sidebar.message.establishments")
                        : this.$t("message.generics.message.spots"),
                    disabled: this.isFilterTabDisabled,
                },
            ];
        },
        user() {
            return this.$store.state.users.user;
        },
        editUrl() {
            return `/campanhas/${this.id}/interacoes`;
        },

        advertising() {
            return this.$store.state.advertising.list;
        },

        isGeneralTab() {
            if (!this.tab) return false;

            return this.tab.value === "GENERAL";
        },

        isFilterTab() {
            if (!this.tab) return false;

            return this.tab.value === "FILTER";
        },

        readonly() {
            return this.data.podeEditar === false;
        },

        canCreateCampaing() {
            return this.user.permissions.find((x) => x === "CREATE_CAMPAIGN")
                ? true
                : true;
        },

        list() {
            return this.isPartner ? this.establishments : this.locals;
        },

        loaded() {
            return this.isPartner
                ? this.establishmentsLoaded
                : this.localsLoaded;
        },

        loadError() {
            return this.isPartner ? this.establishmentsError : this.localsError;
        },

        isPartner() {
            return (
                this.$store.state.users.user &&
                this.$store.state.users.user.tipo === "PARCEIRO"
            );
        },

        test() {
            return this.selectedEstablishments;
        },
    },

    methods: {
        setIsOpenArray({ id, isOpen }) {
            if (isOpen) {
                const hasItem = this.isOpenArray.find((nodeId) => {
                    return id === nodeId;
                });

                if (!hasItem) {
                    this.isOpenArray.push(id);
                }
            } else {
                this.isOpenArray.filter((nodeId) => {
                    return nodeId === id;
                });
            }
        },
        emitOpenEvents() {
            if (!this.isPartner) return;

            this.isOpenArray.forEach((id) => {
                setTimeout(() => {
                    EventBus.$emit("OPEN_NODE", id);
                }, 200);
            });
        },
        collectNodeAndDescendants(node) {
            const result = [node];

            (node.children || []).forEach((child) => {
                result.push(...this.collectNodeAndDescendants(child));
            });

            return result;
        },
        async toogleNode(node) {
            if (node.__togglePending) return;

            const affected = this.collectNodeAndDescendants(node);
            if (affected.some((item) => item.__togglePending)) return;

            if (this.isPartner) EventBus.$emit("SHOW_SPINNER");

            affected.forEach((item) => {
                item.__togglePending = true;
            });
            this.pendingToggleCount++;

            const previousSelected = affected.map((item) => item.selected);
            const nextSelected = !node.selected;

            affected.forEach((item) => {
                if (item.isAuthorized === false) return;

                item.selected = nextSelected;
            });

            try {
                await this.$api.advertising.toogleDeviceFilter({
                    id: this.data.id,
                    itemLocalId: node.type === LOCAL_TREE_TYPE.ESTABLISHMENT ? node.id : node.localTreeId,
                    type: node.type,
                });

                if (this.isPartner) {
                    EventBus.$emit("RELOAD_LOCAL_FILTER_TREE");
                } else {
                    this.needsLocalFilterReload = true;
                }
            } catch (error) {
                affected.forEach((item, index) => {
                    item.selected = previousSelected[index];
                });

                console.log(error);
            } finally {
                affected.forEach((item) => {
                    item.__togglePending = false;
                });
                this.pendingToggleCount--;

                if (!this.isPartner && this.pendingToggleCount === 0 && this.needsLocalFilterReload) {
                    this.needsLocalFilterReload = false;
                    this.debouncedReloadLocalFilterTree();
                }

                if (this.isPartner) {
                    setTimeout(() => {
                        this.emitOpenEvents();

                        EventBus.$emit("CANCEL_SPINNER");
                    }, 500);
                }
            }
        },
        async toggleNodeEstablishment(val) {
            const arrayWithEstablishmentsIds = Object.keys(
                this.selectedEstablishments
            );
            if (arrayWithEstablishmentsIds.length === 0) {
                this.checkIfEstablishmentWasAlreadySelectedAndHandleToggle(val);
            } else {
                if (arrayWithEstablishmentsIds.includes(val.toString())) {
                    delete this.selectedEstablishments[val];
                } else {
                    this.checkIfEstablishmentWasAlreadySelectedAndHandleToggle(
                        val
                    );
                }
            }
        },
        checkIfEstablishmentWasAlreadySelectedAndHandleToggle(val) {
            const establishmentSelected = this.establishments.find(
                (establishment) => establishment.id === val
            );

            if (establishmentSelected && establishmentSelected.selected) {
                this.selectedEstablishments[val] = establishmentSelected.weight;
            } else {
                this.selectedEstablishments[val] = null;
            }
        },
        async load($state) {
            if (this.isPartner) {
                await this.loadEstablishments($state);
            } else {
                await this.loadLocals($state);
            }
        },
        async loadLocals($state) {
            const requestId = ++this.localsRequestId;

            try {
                this.localsLoaded = false;
                this.localsError = false;

                const list = await this.$api.advertising.devicesFilterList({
                    id: this.data.id,
                    isAnunciante: this.isAnunciante,
                });

                if ($state) {
                    $state.loaded();
                    $state.complete();
                }

                if (requestId !== this.localsRequestId) return;

                this.locals = normalizeSelection(list);
                this.localsLoaded = true;
            } catch (error) {
                if ($state) {
                    $state.loaded();
                    $state.complete();
                }

                if (requestId !== this.localsRequestId) return;

                this.localsError = true;

                console.log(error);

                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t("message.errorMessages.message.loadLocalsError"),
                });
            }
        },
        async loadEstablishments($state) {
            const requestId = ++this.establishmentsRequestId;

            try {
                this.establishmentsLoaded = false;
                this.establishmentsError = false;

                this.selectedEstablishments = {};

                const list =
                    await this.$api.core.partner.campaign.getPartnerCampaignEstablishmentsList(
                        this.data.id
                    );

                if ($state) {
                    $state.loaded();
                    $state.complete();
                }

                if (requestId !== this.establishmentsRequestId) return;

                this.establishments = list;

                this.establishments.map((establishment) => {
                    if (establishment.selected) {
                        this.selectedEstablishments[establishment.id] =
                            establishment.weight;
                    }
                });

                this.establishmentsLoaded = true;
            } catch (error) {
                if ($state) {
                    $state.loaded();
                    $state.complete();
                }

                if (requestId !== this.establishmentsRequestId) return;

                this.establishmentsError = true;

                console.log(error);

                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t("message.errorMessages.message.loadEstablishmentsError"),
                });
            }
        },
        validate() {
            this.$refs.body.validate();
        },

        async save() {
            const isEdit = this.edit;

            if (!isEdit) {
                if (this.isGeneralTab) {
                    const advertising = await this.$api.advertising.create({
                        id: this.data.id,
                        data: this.data,
                    });

                    this.data = advertising;

                    EventBus.$emit("load-advertising", {});

                    this.isGeneralTabDisabled = true;
                    this.isFilterTabDisabled = false;

                    this.tab = this.tabs[1];
                } else {
                    if (this.isPartner) {
                        const hasNullWeight =
                            this.checkIfSelectedEstablishmentsHaveNullWeights();
                        if (hasNullWeight) {
                            return EventBus.$emit("show-message", {
                                type: "ERROR",
                                message: this.$t(
                                    "message.errorMessages.message.selectEstablishmentWeight"
                                ),
                            });
                        }
                        await this.$api.core.partner.campaign.linkPartnerCampaignToEstablishment(
                            this.selectedEstablishments,
                            this.data.id
                        );
                    }
                    this.$router.push({
                        name: "INTERACTIONS",
                        params: { id: this.data.id },
                    });
                }
            } else {
                if (this.isPartner && this.isFilterTab) {
                    const hasNullWeight =
                        this.checkIfSelectedEstablishmentsHaveNullWeights();
                    if (hasNullWeight) {
                        return EventBus.$emit("show-message", {
                            type: "ERROR",
                            message: this.$t(
                                "message.errorMessages.message.selectEstablishmentWeight"
                            ),
                        });
                    }
                    await this.$api.core.partner.campaign.linkPartnerCampaignToEstablishment(
                        this.selectedEstablishments,
                        this.data.id
                    );
                }

                const advertising = await this.$api.advertising.edit({
                    id: this.data.id,
                    data: this.data,
                });

                this.data = advertising;

                EventBus.$emit("load-advertising", {});

                this.show = false;
            }
        },

        resetLocalsState() {
            this.debouncedReloadLocalFilterTree.cancel();

            this.locals = [];
            this.establishments = [];
            this.localsLoaded = false;
            this.establishmentsLoaded = false;
            this.localsError = false;
            this.establishmentsError = false;
            this.localsRequestId++;
            this.establishmentsRequestId++;
        },

        async reset() {
            this.isFilterTabDisabled = true;
            this.tab = this.tabs[0];
            this.edit = false;
            this.id = null;
            this.resetLocalsState();
            this.data = {
                nome: "",
                dataInicio: new Date().toISOString().substring(0, 10),
                dataFim: new Date().toISOString().substring(0, 10),
                horaInicio: "00:00",
                horaFim: "23:59",
                isTodosDias: true,
                isDiaInteiro: true,
                isBirthdate: false,
                diasSemana: [0, 1, 2, 3, 4, 5, 6],
                filtroSexo: null,
                filtroIdadeInicial: 0,
                filtroIdadeFinal: 100,
                filtrosAparelhos: [],
                allCaptiveLoginTypeSelected: true,
                allSsidSelected: true,
                captiveLoginTypeFilter: [],
                anuncianteId: null,
                anuncianteNome: null,
                anuncianteIsAtivo: null,
                paginaPosAutenticacao: null,
            };
        },

        input(value) {
            this.data = value;
        },

        editAdvertisementHandler(item) {
            this.isFilterTabDisabled = false;
            this.data = JSON.parse(JSON.stringify(item));
            this.show = true;
            this.edit = true;
            this.id = this.data.id;
            this.resetLocalsState();
            this.$nextTick(() => (this.tab = this.tabs[0]));
        },

        setPriority(val) {
            for (const [key] of Object.entries(this.selectedEstablishments)) {
                if (key === val.establishmentId.toString()) {
                    this.selectedEstablishments[key] = val.priority;
                }
            }
        },

        checkIfSelectedEstablishmentsHaveNullWeights() {
            return Object.values(this.selectedEstablishments).some(
                (value) => value === null
            );
        },
    },

    watch: {
        show(show) {
            if (show) {
                this.$nextTick(() => EventBus.$emit("RESET_ADVERTISING_MODAL"));
            } else {
                this.debouncedReloadLocalFilterTree.cancel();
            }
        },
    },

    created() {
        this.debouncedReloadLocalFilterTree = debounce(() => {
            EventBus.$emit("RELOAD_LOCAL_FILTER_TREE");
        }, 600);
    },

    mounted() {
        this.tab = this.tabs[0];

        EventBus.$on("edit-advertisement", this.editAdvertisementHandler);
    },

    beforeDestroy() {
        this.debouncedReloadLocalFilterTree.cancel();

        EventBus.$off("edit-advertisement", this.editAdvertisementHandler);
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.v-card {
    overflow-y: auto;
}

.card-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 15px;

    .btn {
        margin: 15px;
    }
}
</style>
